import { render, staticRenderFns } from "./OrgLicenseCard.vue?vue&type=template&id=40212bb2&scoped=true"
import script from "./OrgLicenseCard.vue?vue&type=script&lang=js"
export * from "./OrgLicenseCard.vue?vue&type=script&lang=js"
import style0 from "./OrgLicenseCard.vue?vue&type=style&index=0&id=40212bb2&prod&lang=scss&scoped=true"
import style1 from "./OrgLicenseCard.vue?vue&type=style&index=1&id=40212bb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40212bb2",
  null
  
)

export default component.exports